var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "25px",
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.524079,0 20,4.27335 20,9.547422 C20,16.931122 10,25 10,25 C10,25 0,17.129463 0,9.547422 C0,4.27335 4.475921,0 10,0 Z M10.056657,6.419041 C9.013627,6.419041 8.168083,7.226317 8.168083,8.222142 C8.168083,9.217967 9.013627,10.025243 10.056657,10.025243 C11.099688,10.025243 11.945231,9.217967 11.945231,8.222142 C11.945231,7.226317 11.099688,6.419041 10.056657,6.419041 Z",
    id: "Location"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4d6035003c1daaba3b204de71a223a4e.svg";
export { ForwardRef as ReactComponent };